// How a text-carrying action node decides WHAT text to act on.
//
// Two nodes take a line — Send Text Input (the user's turn, to the LLM) and Say
// Line (the character's own turn, straight to TTS) — and both follow Unreal's
// rule for a typed input: the wired pin wins, the inline field is the fallback
// when nothing is wired. The subtlety that earns this its own module is that
// "nothing wired" and "wired to something empty" are different, and only one of
// them should fall back: a pin wired to a variable that evaluates to "" is the
// graph SAYING empty, and silently substituting the inline default there makes
// the node speak a line the author thought they had overridden.
//
// _resolveDataPin reports an unwired pin as null, which is what separates the
// two cases — no other value can mean "not wired", since a wired pin that
// resolves to nothing gives ''.
//
// Pure and importable under `node --test`; EventRuntime.js itself is not
// (extensionless relative imports), which is exactly why this lives here.

/**
 * @param {*} wired   the `_resolveDataPin` result: null when the pin is unwired
 * @param {*} inline  the node's own `data.text`
 * @returns {string}  the text to act on — '' means "act on nothing"
 */
export function resolveTextPin(wired, inline) {
  if (wired !== null && wired !== undefined) return String(wired)
  return typeof inline === 'string' ? inline : (inline == null ? '' : String(inline))
}
